import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { RealignmentOrdersService } from '@app/core/services';
import { MatSort, Sort } from '@angular/material/sort';
import { select, State, Store } from '@ngrx/store';
import { MatDialog } from '@angular/material/dialog';
import { RealignmentOrdersActionTypes, AppState } from '@app/core/ngrx';
import { RealignmentOrderConfirmComponent } from '@app/realignment-orders/components/realignment-order-confirm/realignment-order-confirm.component';
import { Observable } from 'rxjs';

@Component({
  selector: 'ecp-realignment-orders-detail-card',
  templateUrl: './realignment-orders-detail-card.component.html',
  styleUrls: ['./realignment-orders-detail-card.component.scss'],
})
export class RealignmentOrdersDetailCardComponent implements OnInit {
  @Input()
  order;

  panelDisplay: Array<number> = [];
  @ViewChild('sortSection') sortSection: ElementRef;
  @ViewChild(MatSort) sort: MatSort;
  sortedData: Array<any>;
  isProcessDateCurrent: boolean;
  public order$: Observable<any>;
  totalFrames$: any;

  totalFrames: any;
  constructor(
    private realignmentOrdersService: RealignmentOrdersService,
    public dialog: MatDialog,
    private state: State<AppState>,
    private store: Store<AppState>,
  ) {}

  ngOnInit() {
    this.sortedData = this.order.frames.slice();
    let today = new Date().getDate();
    let processDate = new Date(this.order.processDate).getDate();
    this.isProcessDateCurrent = processDate == today;
  }

  toggleHold(order) {
    this.realignmentOrdersService
      .toggleHold({
        orderId: order.orderId,
        onHold: !order.onHold,
      })
      .subscribe(resp => {
        console.log(resp);
        let notificationOptions = {
          title: 'Notification',
          contentHtml: 'Realignment Order updated.',
          confirmBtnText: 'Close',
        };
        this.store.dispatch({ type: RealignmentOrdersActionTypes.LOAD_REALIGNMENT_ORDERS });
      });
  }

  openReturnConfirmDialog(order): void {
    const dialogRef = this.dialog.open(RealignmentOrderConfirmComponent, {
      width: '600px',
      maxWidth: '89.3vw',
      maxHeight: '82vh',
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed with ' + result);
      if (result === true) {
        this.realignmentOrdersService
          .releaseOrder({
            orderId: order.orderId,
          })
          .subscribe(() => {
            this.store.dispatch({
              type: RealignmentOrdersActionTypes.LOAD_REALIGNMENT_ORDERS,
            });
          });
      }
    });
  }

  sortData(sort: Sort): void {
    const data = this.order.frames.slice();
    if (!sort.active || sort.direction === '') {
      this.sortedData = data;
      return;
    }

    this.sortedData = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'styleName':
          return compare(a.styleName, b.styleName, isAsc);
        case 'colorDescription':
          return compare(a.colorDescription, b.colorDescription, isAsc);
        case 'eyeSize':
          return compare(a.eyeSize + '-' + a.temple, b.eyeSize + '-' + b.temple, isAsc);
        case 'upc':
          return compare(a.upc, b.upc, isAsc);
        default:
          return 0;
      }
    });
  }
}

function compare(a: number | string, b: number | string, isAsc: boolean) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}
